module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAWCAYAAADAQbwGAAAABHNCSVQICAgIfAhkiAAAAMNJREFUOI3NlNsNgzAMRU8Qs4Rlmjk6QOboAJ2DLkOm6QdOa6V5kSK1V0IYxzoYXWNDWxZwEm/Ao1ZsGiAvcVA5gJvKdesuQJvkvZxlNRXyl0onq9zTF1WBSwYUFeRyucMScFinA6PLejTiM5Q/Oz3fJA6G3QCXFBzVa5xmlbwOwqI84Cbqjh7W/7v8M6Dl/TtWNbdLPsaqamBPhxqQXQhaPR0G9g3T7K4XCI0trXWmyxbYDPlVPwpc47aJI7F8AVyB8ATANiNGercCyAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/loginlock.png
// module id = 1SkA
// module chunks = 1